/* SearchPageField - migrated to Tailwind */
export const searchPageFieldClassName = 'search-page-field';
